module.exports = __webpack_public_path__ + "static/media/browse-chargers.2181464b.svg";